<template>
	<ja-modal v-if="showModal" ref="modal" :show="show">
		<content>
			<h1>{{ $t('studentLoanPaymentTitle') }}</h1>
			<div class="container">
				<div class="img-container">
					<img
						alt=""
						class="books-image"
						:src="require(`@/assets/images/books.png`)"
					/>
				</div>
				<div v-if="showTotalLoan" class="payment-amount-container">
					<div class="modal-text-field bold">
						<span>{{ $t('totalLoanAmountToPay') }}</span>
						<span name="totalAmount"> {{ totalAmount | currency }}</span>
					</div>
					<div class="modal-text-field uppercase">
						<span>{{ $t('tuition') }}</span>
						<span name="tuition"> {{ tuition | currency }}</span>
					</div>
					<div class="modal-text-field uppercase">
						<span>{{ $t('interest') }} </span>
						<span name="interest">{{ interest | currency }}</span>
					</div>
				</div>
				<div v-else class="payment-amount-container">
					<div class="modal-text-field bold">
						<span>{{ $t('studentLoanAmountLeftToPay') }}</span>
						<span name="studentLoanAmountLeftToPay">
							{{ loanDebtLeft | currency }}</span
						>
					</div>
				</div>
				<div class="payment-amount-container">
					<div class="modal-text-field bold">
						<span>{{ $t('minimumPaymentDue') }}</span>
						<span name="minimumPaymentDue">{{
							minimumPaymentDue | currency
						}}</span>
					</div>

					<label
						for="monthly-payment-amount"
						class="label-monthly-payment-amount"
					>
						{{ $t('monthlyPaymentAmount') }}</label
					>
					<ja-currency-input
						id="monthly-payment-amount"
						v-model="amountToPay"
						name="monthly-payment-amount"
						class="input-monthly-payment-amount"
						required
						autocomplete="off"
						:min-value="minimumPaymentDue"
						@amountPerMonth="amountPerMonth"
					>
					</ja-currency-input>

					<ja-alert-bar
						class="alert-bar-payment-amount"
						:alert-condition="alertForLowerAmount"
						>{{ $t('errorMessageLowerAmount') }}</ja-alert-bar
					>

					<ja-dropdown
						class="payment-method"
						:label="$t('paymentMethod')"
						:options="paymentMethods"
						name="paymentMethod"
						:placeholder="
							JA_LOCALIZATION_IRL ? $t('debitAccount') : $t('checkingAccount')
						"
					></ja-dropdown>

					<div class="modal-text-field">
						<span>{{
							JA_LOCALIZATION_IRL ? $t('debitAccount') : $t('checkingAccount')
						}}</span>
						<span
							:name="
								JA_LOCALIZATION_IRL ? $t('debitAccount') : $t('checkingAccount')
							"
							>{{ checkingAccount | currency }}
						</span>
					</div>

					<ja-alert-bar
						class="alert-bar-checking-account"
						:alert-condition="alertForNotEnoughMoneyInAccount"
						>{{ $t('noticeForNotEnoughMoneyInChechingAccount') }}</ja-alert-bar
					>
				</div>
			</div>

			<div class="btn-container">
				<ja-button
					v-if="showMakePaymentBtn"
					class="small"
					name="makePayment"
					:disabled="!checkIfMontholyPaymentIsValid()"
					@click.native="makePayment"
				>
					{{ $t('makePayment') }}</ja-button
				>
				<ja-button
					v-if="!showMakePaymentBtn"
					class="small"
					name="makePaymentWithoutPayment"
					@click.native="endStudentLoanPayment"
				>
					{{ $t('okay') }}</ja-button
				>
			</div>
		</content>
	</ja-modal>
</template>
<script>
import gql from 'graphql-tag';
import Modal from './Modal';
import Button from '../ui/Button';
import CurrencyInput from '@/components/ui/CurrencyInput';
import Dropdown from '@/components/ui/form/Dropdown';
import LifeStageData from '@/mixins/LifeStageData';
import ProfileData from '@/mixins/ProfileData';
import ModalEvents from '@/mixins/ModalEvents';
import AlertBar from '@/components/ui/AlertBar';

export default {
	components: {
		jaModal: Modal,
		jaButton: Button,
		jaCurrencyInput: CurrencyInput,
		jaDropdown: Dropdown,
		jaAlertBar: AlertBar
	},
	mixins: [LifeStageData, ProfileData, ModalEvents],

	props: {
		show: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			JA_LOCALIZATION_IRL: this.$store.getters.isIrl,
			alertForLowerAmount: false,
			alertForNotEnoughMoneyInAccount: false,
			amountToPay: null,
			showMakePaymentBtn: true,
			showModal: true
		};
	},
	computed: {
		paymentMethods() {
			return [
				{
					name: `${
						this.JA_LOCALIZATION_IRL
							? this.$t('debitAccount')
							: this.$t('checkingAccount')
					}`,
					value: `${
						this.JA_LOCALIZATION_IRL
							? this.$t('debitAccount')
							: this.$t('checkingAccount')
					}`
				}
			];
		},
		userData() {
			return this.$store.getters.userData;
		},
		totalAmount() {
			return this.profileData.totalStudentLoan;
		},
		loanDebtLeft() {
			return this.profileData.studentLoanDebt;
		},
		interest() {
			return this.totalAmount - this.tuition;
		},
		minimumPaymentDue() {
			return this.profileData.minimumStudentLoanPayment;
		},
		checkingAccount() {
			return this.netMonthlyIncome - this.lifeStageData.totalExpenses;
		},
		tuition() {
			return this.profileData.cmsEducation.tuition;
		},
		monthlyPaymentIsValid() {
			return this.amountToPay >= Math.round(this.minimumPaymentDue);
		},
		validIfEnoughInCheckingAccount() {
			return (
				this.checkingAccount >= Math.round(this.minimumPaymentDue) &&
				this.amountToPay <= this.checkingAccount &&
				this.amountToPay >= Math.round(this.minimumPaymentDue)
			);
		},
		showTotalLoan() {
			return this.totalAmount === this.loanDebtLeft;
		}
	},
	watch: {
		amountToPay() {
			this.checkIfMontholyPaymentIsValid();
		}
	},
	methods: {
		amountPerMonth(amount) {
			this.amountToPay = amount;
		},
		checkIfMontholyPaymentIsValid() {
			if (this.checkingAccount >= Math.round(this.minimumPaymentDue)) {
				return this.validIfEnoughInCheckingAccount;
			} else {
				return this.monthlyPaymentIsValid;
			}
		},

		async makePayment() {
			if (this.checkIfMontholyPaymentIsValid) {
				if (this.amountToPay > this.checkingAccount) {
					this.showMakePaymentBtn = false;
					this.alertForNotEnoughMoneyInAccount = true;
					this.alertForLowerAmount = false;
				} else {
					const payedAmount = {
						studentId: this.userData.studentId,
						payedAmount: this.amountToPay,
						lifeStage_ID: this.lifeStageData.lifeStage_ID,
						paymentType: 'Tuition'
					};

					const response = await this.$apollo.mutate({
						mutation: gql`
							mutation AddStudentLoan(
								$add: StudentPaymentAddInputObjectGraphType!
							) {
								addStudentPayment(add: $add) {
									id
								}
							}
						`,
						variables: {
							add: payedAmount
						}
					});
					if (response.data) {
						this.endStudentLoanPayment();
					}
				}
			} else {
				this.alertForLowerAmount = true;
				this.$announcer.assertive(
					`Error: ${this.$t('errorMessageLowerAmount')}`
				);
			}
		},
		async endStudentLoanPayment() {
			this.$store.commit('setLoading', true);

			const studentLoanInfo = {
				id: this.userData.studentId,
				hideLoanPaymentPopup: true
			};

			const response = await this.$apollo.mutate({
				mutation: gql`
					mutation($update: StudentInputObjectGraphType!) {
						updateIgnoreNullValuesStudent(update: $update) {
							hideLoanPaymentPopup
						}
					}
				`,
				variables: {
					update: studentLoanInfo
				}
			});
			if (response.data) {
				this.$store.commit('setLoading', false);
				this.$emit('closeStudenLoanModal');
				this.showModal = false;
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.container {
	height: auto;
	width: 100%;
	border-top: 1px solid $button-border;
	border-bottom: 1px solid $button-border;

	.img-container {
		.books-image {
			margin: 33px auto;
		}
	}

	.payment-amount-container {
		width: 70%;
		margin: auto;
		padding-top: 20px;
		padding-bottom: 20px;
		display: flex;
		flex-direction: column;

		&:nth-child(3) {
			border-top: 1px solid $button-border;
		}

		.label-monthly-payment-amount {
			font-family: 'RobotoMedium';
			font-size: 12px;
			text-transform: uppercase;
			text-align: left;
			color: #687682;
			font-weight: 500;
			letter-spacing: 1px;
			margin-top: 20px;
			margin-bottom: 4px;

			@media (min-width: $breakpoint-mid) {
				font-size: 14px;
			}
		}

		.input-monthly-payment-amount {
			margin-bottom: 15px;
		}
		.alert-bar-payment-amount,
		.alert-bar-checking-account {
			word-break: break-word;
			border: 1px solid $alert-container-border-color;
			border-radius: 4px;
			padding: 8px;
			margin-bottom: 20px;
		}
	}
}

.btn-container {
	height: 76px;
	display: flex;
	align-items: center;

	.make-payment-btn {
		display: block;

		&:hidden {
			display: none;
		}
	}

	.okay-payment-btn {
		display: none;

		&:visible {
			display: block;
		}
	}
}
.modal-text-field {
	display: flex;
	justify-content: space-between;
	color: $icon-done;
	font-family: 'RobotoRegular';
	line-height: 19px;
	padding-bottom: 12px;
	padding-top: 12px;

	.bold {
		color: $font-header;
	}

	.uppercase {
		text-transform: uppercase;
	}
}
</style>
